<template>
  <div id="awards">
    <div class="m-auto max-w-full">
      <div class="grid grid-cols-3 lg:grid-cols-6 lg:items-center gap-8 lg:gap-4">
        <div
          v-for="({ image, category, place }, index) in awards"
          :key="index"
          class="flex flex-col items-center">
          <component :is="image" class="size-20" />
          <p class="w-[100px] lg:w-full text-[12px] mt-3 text-center">
            {{ category }}<br /><span class="font-bold">{{ place }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import FinniesWealthManagement2023 from '@/components/SVGS/Awards/finnies-2023.svg'
import FinniesOrganisationOfTheYear2024 from '@/components/SVGS/Awards/finnies-2024-finalist.svg'
import IFADigitalAdviceStrategy2023 from '@/components/SVGS/Awards/ifa-2023-dasoty.svg'
import AWMAExecutive2025 from '@/components/SVGS/Awards/awma-2025-eotyda.svg'
import AWMAInnovator2025 from '@/components/SVGS/Awards/awma-2025-iotyda.svg'
import IFAStrategy2022 from '@/components/SVGS/Awards/ifa-2022-dsoty-winner.svg'

type Award = {
  image: unknown
  category: string
  place: string
}

interface Props {
  awards?: Array<Award>
}

withDefaults(defineProps<Props>(), {
  awards: () => [
    {
      image: AWMAInnovator2025,
      category: 'Innovator of the Year',
      place: 'Finalist 2025',
    },
    {
      image: AWMAExecutive2025,
      category: 'Executive of the Year',
      place: 'Finalist 2025',
    },
    {
      image: FinniesOrganisationOfTheYear2024,
      category: 'Fintech Organisation of the Year 2024',
      place: 'Finalist 2024',
    },
    {
      image: IFADigitalAdviceStrategy2023,
      category: 'Digital Advice Strategy of the Year',
      place: 'Finalist 2023',
    },
    {
      image: FinniesWealthManagement2023,
      category: 'Excellence in Wealth Management',
      place: 'Finalist 2023',
    },
    {
      image: IFAStrategy2022,
      category: 'Digital Advice Strategy of the Year',
      place: 'Winner 2022',
    },
  ],
})
</script>
